import { useEffect, useState } from "react";

import { useAccessToken } from "../auth-provider";
import { loadDeviceImageUrl } from "../service/device-image-service";

/**
 * Resolve a device's DeviceTypeImage (from OPC-UA) to a displayable URL.
 * Returns `fallback` (the static default image) when the device exposes no
 * image or while the authenticated fetch is pending/failed — so behaviour is
 * unchanged for devices without a DeviceTypeImage.
 */
export function useDeviceImage(
  links: string[] | undefined,
  fallback: string
): string {
  const accessToken = useAccessToken();
  const [url, setUrl] = useState(fallback);

  useEffect(() => {
    const link = links?.[0];
    const promise = link
      ? loadDeviceImageUrl(link, accessToken || undefined)
      : undefined;
    if (!promise) {
      setUrl(fallback);
      return;
    }

    let cancelled = false;
    promise
      .then((objectUrl) => {
        if (!cancelled) setUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setUrl(fallback);
      });
    return () => {
      cancelled = true;
    };
  }, [links, fallback, accessToken]);

  return url;
}
